<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> General
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consultas</span>
      <span> /</span>
      <span class="grey-text">Inventario</span>
      <span> /</span>
      <span>General</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">


      <div class="row filtros-body">
        <div class="col" style="max-width: 200PX;">
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" id="rbVistaResumen" [value]="RB_TIPO_VISTA_RESUMEN"
              formControlName="tipoVista" mdbInput />
            <label class="form-check-label" for="rbVistaResumen">Vista Resumen</label>
          </div>

          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" [value]="RB_TIPO_VISTA_DETALLE"
              formControlName="tipoVista" mdbInput />
            <label class="form-check-label" for="rbVistaDetalle">Vista Detalle</label>
          </div>
        </div>
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fecha_movimiento" [placeholder]="'Fecha Mov.'" required
              formControlName="fecha_movimiento"></mdb-date-picker>
            <div *ngIf="
                                              formHeader.get('fecha_movimiento').invalid &&
                                              (formHeader.get('fecha_movimiento').dirty ||
                                              formHeader.get('fecha_movimiento').touched)
                                            ">
              <mdb-error *ngIf="formHeader.get('fecha_movimiento').hasError('required')">
                Ingrese fecha movimiento
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega" formControlName="bodega">
            </mdb-select>
            <label>Bodega</label>
            <div *ngIf="
                              formHeader.get('bodega').invalid &&
                              (formHeader.get('bodega').dirty ||
                              formHeader.get('bodega').touched)
                            ">
              <mdb-error *ngIf="formHeader.get('bodega').hasError('required')">
                Ingrese bodega(s)
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Rubro" formControlName="rubro">
            </mdb-select>
            <label>Rubro</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Familia" formControlName="familia">
            </mdb-select>
            <label>Familia</label>
          </div>
        </div>

        <!-- <div class="col" style="max-width: 300px;display: none;">
                    <mdb-checkbox formControlName="filtraSaldo" checked>Filtrar por saldo</mdb-checkbox>
                </div> -->
        <div class="col" style="max-width: 300px;">
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline" style="margin-right: 20px;">
            <!-- <input type="radio" class="form-check-input" id="materialInlineMayor0"
                            [value]="TIPO_MAYOR_A_CERO" formControlName="mayorCero" mdbInput />
                        <label class="form-check-label" for="materialInlineMayor0">Saldo Mayor a 0</label> -->
            <mdb-checkbox formControlName="mayorCero">Saldo Mayor a 0</mdb-checkbox>
          </div>

          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <!-- <input type="radio" class="form-check-input" id="materialInlineIgual0"
                            [value]="TIPO_IGUAL_A_CERO" formControlName="mayorCero" mdbInput />
                        <label class="form-check-label" for="materialInlineIgual0">Saldo Iguales a 0</label> -->
            <mdb-checkbox formControlName="igualCero">Saldo Iguales a 0</mdb-checkbox>
          </div>
          <div class="form-check form-check-inline">
            <!-- <input type="radio" class="form-check-input" id="materialInlineIgual0"
                            [value]="TIPO_IGUAL_A_CERO" formControlName="mayorCero" mdbInput />
                        <label class="form-check-label" for="materialInlineIgual0">Saldo Iguales a 0</label> -->
            <mdb-checkbox formControlName="incluirInactivo">Incluir Desactivados</mdb-checkbox>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div *ngIf="resumen_loading || detalle_loading" class="w-100 d-block text-center">
      <mdb-spinner *ngIf="resumen_loading || detalle_loading" spinnerColor="blue"></mdb-spinner>
    </div>

    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
      <app-no-data-alert *ngIf="resumen_listaMovimientos?.length === 0"></app-no-data-alert>
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="resumen_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Producto</th>
            <th scope="col">Bodega</th>
            <th scope="col">UXE</th>
            <th scope="col">Rubro</th>
            <th scope="col">Familia</th>
            <th scope="col">Caja</th>
            <th scope="col">Unidad</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let mov of resumen_listaMovimientos">
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.sku}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.sku}}</span>
            </td>
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.producto_descripcion}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.producto_descripcion}}</span>
            </td>
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.bodega_nombre}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.bodega_nombre}}</span>
            </td>
            <td align="left">
              <span *ngIf="!mov.producto_activo"
                class="blue-text">{{obtenerFormatoPrincipal(mov.listaStockxUnidades).cantidad_formato}}</span>
              <span *ngIf="mov.producto_activo"
                class="black-text">{{obtenerFormatoPrincipal(mov.listaStockxUnidades).cantidad_formato}}</span>
            </td>
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.rubro_nombre}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.rubro_nombre}}</span>
            </td>
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.familia_nombre}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.familia_nombre}}</span>
            </td>
            <td align="left">
              <span *ngIf="!mov.producto_activo"
                class="blue-text">{{calcularCajasResumenSinCruceBodegas(mov.listaStockxUnidades)}}</span>
              <span *ngIf="mov.producto_activo"
                class="black-text">{{calcularCajasResumenSinCruceBodegas(mov.listaStockxUnidades)}}</span>
            </td>
            <td align="left">
              <span *ngIf="!mov.producto_activo"
                class="blue-text">{{calcularUnidadesResumenSinCruceBodegas(mov.listaStockxUnidades)}}</span>
              <span *ngIf="mov.producto_activo"
                class="black-text">{{calcularUnidadesResumenSinCruceBodegas(mov.listaStockxUnidades)}}</span>
            </td>
          </tr>
        </tbody>
        <!-- TOTALES -->
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="6"><strong></strong></td>
            <td class="text-left">
              <strong>
                <span style="color: red;">Total Cajas </span>
                <span>{{(detalle_totales != null ? detalle_totales.saldo_total : resumen_totales?.saldo_total) | numerico}}</span>
              </strong>
            </td>
            <td class="text-left">
              <strong>
                <span style="color: red;">Total Unidades </span>
                <span>{{(detalle_totales != null ? detalle_totales.saldo_total_unidad : resumen_totales?.saldo_total_unidad) | numerico}}</span>
              </strong>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="resumen_paginationContext" (onPageChange)="resumenOnPageChange($event)"
          *ngIf="resumen_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>

    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalle_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Producto</th>
            <th scope="col">Formato</th>
            <th scope="col">UXE</th>
            <th scope="col">Bodega</th>
            <th scope="col">Rubro</th>
            <th scope="col">Familia</th>
            <th scope="col">Caja</th>
            <th scope="col">Unidad</th>
            <th scope="col" style="text-align: left;">Costo</th>
            <th scope="col" style="text-align: right;">C.Unitario</th>
            <th scope="col" style="text-align: right;">Prec1</th>
            <th scope="col" style="text-align: right;">Prec2</th>
            <th scope="col" style="text-align: right;">Prec3</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let mov of detalle_listaMovimientos">
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.sku}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.sku}}</span>
            </td>
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.producto_descripcion}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.producto_descripcion}}</span>
            </td>
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.formato_nombre}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.formato_nombre}}</span>
            </td>
            <td>
              <span *ngIf="!mov.producto_activo"
                class="blue-text">{{obtenerCantidadFormato(mov.listaStockxUnidadesxBodega, mov.formato_codigo)}}</span>
              <span *ngIf="mov.producto_activo"
                class="black-text">{{obtenerCantidadFormato(mov.listaStockxUnidadesxBodega, mov.formato_codigo)}}</span>
            </td>
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.bodega_nombre}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.bodega_nombre}}</span>
            </td>
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.rubro_nombre}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.rubro_nombre}}</span>
            </td>
            <td>
              <span *ngIf="!mov.producto_activo" class="blue-text">{{mov.familia_nombre}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{mov.familia_nombre}}</span>
            </td>
            <td align="left">
              <span *ngIf="!mov.producto_activo" class="blue-text">
                {{mov.caja}}
              </span>
              <span *ngIf="mov.producto_activo" class="black-text">
                {{mov.caja}}
              </span>
            </td>
            <td align="left">
              <span *ngIf="!mov.producto_activo" class="blue-text">
                {{mov.fraccion}}
              </span>
              <span *ngIf="mov.producto_activo" class="black-text">
                {{mov.fraccion}}
              </span>
            </td>
            <td align="right">
              <span *ngIf="!mov.producto_activo" class="blue-text">{{
                calcularCostoTodosLosFormatosSegunFormato(mov.listaStockxUnidadesxBodega, mov.formato_codigo,
                mov.producto_codigo) | numerico}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{
                calcularCostoTodosLosFormatosSegunFormato(mov.listaStockxUnidadesxBodega, mov.formato_codigo,
                mov.producto_codigo) | numerico}}</span>
            </td>
            <!-- <td align="right">
              <span *ngIf="!mov.producto_activo" class="blue-text">{{
                calcularCostoTodosLosFormatos(mov.listaStockxUnidadesxBodega,
                mov.costo_formato_principal) | numerico}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{
                calcularCostoTodosLosFormatos(mov.listaStockxUnidadesxBodega,
                mov.costo_formato_principal) | numerico}}</span>
            </td> -->

            <td align="right">
              <span *ngIf="!mov.producto_activo" class="blue-text">{{ mov.costo_formato_principal |
                numerico}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{ mov.costo_formato_principal |
                numerico}}</span>
            </td>
            <td align="right">
              <span *ngIf="!mov.producto_activo" class="blue-text">{{ mov.preciosXUnidades[0] ?
                mov.preciosXUnidades[0].precio_neto : "" | numerico}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{ mov.preciosXUnidades[0] ?
                mov.preciosXUnidades[0].precio_neto : "" | numerico}}</span>
            </td>
            <td align="right">
              <span *ngIf="!mov.producto_activo" class="blue-text">{{ mov.preciosXUnidades[1] ?
                mov.preciosXUnidades[1].precio_neto : "" | numerico}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{ mov.preciosXUnidades[1] ?
                mov.preciosXUnidades[1].precio_neto : "" | numerico}}</span>
            </td>
            <td align="right">
              <span *ngIf="!mov.producto_activo" class="blue-text">{{ mov.preciosXUnidades[2] ?
                mov.preciosXUnidades[2].precio_neto : "" | numerico}}</span>
              <span *ngIf="mov.producto_activo" class="black-text">{{ mov.preciosXUnidades[2] ?
                mov.preciosXUnidades[2].precio_neto : "" | numerico}}</span>
            </td>
          </tr>
        </tbody>
        <!-- TOTALES -->
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="6"><strong></strong></td>
            <td class="text-right"><strong></strong></td>
            <td class="text-left">
              <strong>
                <span style="color: red;">Total Cajas </span>
                <span>{{detalle_totales.saldo_total | numerico}}</span>
              </strong>
            </td>
            <td class="text-left">
              <strong>
                <span style="color: red;">Total Unidades </span>
                <span>{{detalle_totales.saldo_total_unidad | numerico}}</span>
              </strong>
            </td>
            <td class="text-left" colspan="5">
              <strong>
                <span style="color: red;">Total Costo </span>
                <span>$ {{detalle_totales.costo_total_total | numerico}}</span>
              </strong>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="detalle_paginationContext" (onPageChange)="detalleOnPageChange($event)"
          *ngIf="detalle_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>

    <!-- <div class="table-responsive" *ngIf="detalle_listaMovimientos?.length > 0">
            <table class="table table-striped table-hover table-sm align-middle">
                <tbody>
                    <tr>
                        <td class="col-10" style="font-weight: bold; font-size: 15px;text-align: right;">
                            <span style="color: red;">Total Cajas </span>
                            <span>{{totalCajas | numerico}}</span>
                            <span style="color: red;"> Total Costo </span>
                            <span>{{costoTotal | numerico}}</span>
                        </td>
                </tbody>
            </table>
        </div> -->
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn size="sm" type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="resumenDownloadExcelPdf('XLS')">Excel</button>
    <button mdbBtn size="sm" type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="resumenDownloadExcelPdf('PDF')">PDF</button>
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn"
      (click)="detalleDownloadExcelPdf('XLS')">Excel</button>
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn"
      (click)="detalleDownloadExcelPdf('PDF')">PDF</button>
  </div>
</div>